import React, { useState } from 'react'
import { BigNumber } from 'ethers'
import { useUpdateMargin } from '../../hooks/contracts/useUpdateMargin'
import { toScaled, toUnscaled } from '../../utils/bn'
import { PrimaryButton } from '../common/Button'
import { AmountForm } from '../common/AmountForm'
import pendingStore from '../../store/pending'
import PendingIndicator from '../common/PendingIndicator'
import { useVaultStatus } from '../../hooks/query/useVaultStatus'
import crossIcon from '../../assets/close.png'
import { MARGIN } from '../../constants'

type Props = {
  onClose: () => void
}

export const WithdrawModal = ({ onClose }: Props) => {
  const updateMargin = useUpdateMargin()
  const { isPendingTx, setPendingTx } = pendingStore()

  const vaultStatusQuery = useVaultStatus()

  const [amount, setAmount] = useState(0)

  const onWithdrawMargin = async (amount: BigNumber) => {
    const tx = await updateMargin.mutateAsync({
      assetGroupId: 1,
      marginAmount: amount.mul(-1)
    })

    await setPendingTx(tx)
  }

  const marginAvailable =
    vaultStatusQuery.isSuccess && vaultStatusQuery.data.mainVault
      ? vaultStatusQuery.data.mainVault.withdrawable
      : BigNumber.from(0)

  const enoughUSDCInVault = marginAvailable.gte(
    toScaled(amount, MARGIN.DECIMALS)
  )

  return (
    <div className="space-y-2">
      <div className="flex items-center justify-end">
        <div
          className="rounded-lg bg-white text-[#809fb8] w-6 h-6 flex items-center justify-center"
          onClick={onClose}
        >
          <img src={crossIcon} />
        </div>
      </div>
      <div className="flex items-center justify-start text-xl">Withdraw</div>
      <div className="px-6">
        <div className="flex items-center justify-center text-sm text-subtext font-normal">
          Predy is a non-custodial protocol; only the wallet can access the
          vault account. You are responsible for your wallet security and can
          withdraw the available cryptocurrency anytime.
        </div>
        <div className="flex items-center justify-center pt-8">
          <AmountForm
            title={'Amount'}
            unit={'USDC'}
            amount={amount}
            onChange={amount => {
              setAmount(amount)
            }}
          />
        </div>
        <div className="flex items-center justify-between text-subtext px-4 pt-4">
          <div>In Vault Available</div>
          <div>
            {toUnscaled(marginAvailable, MARGIN.DECIMALS, MARGIN.SIGNIFICANT)}{' '}
            USDC
          </div>
        </div>
        <div className="flex items-center justify-center pt-8">
          <div className="w-40 h-12 p-1">
            <PrimaryButton
              disabled={!enoughUSDCInVault || isPendingTx || amount <= 0}
              onClick={() => {
                onWithdrawMargin(toScaled(amount, MARGIN.DECIMALS))
              }}
            >
              {isPendingTx ? <PendingIndicator /> : 'Withdraw'}
            </PrimaryButton>
          </div>
        </div>
      </div>
    </div>
  )
}
